import React, { FC, useContext, useRef } from "react";
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { Button, Dialog, DialogActions, DialogContent, Link, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import DownloadPDF from "../Buttons/DownloadPDF";
import { VisibilityContext } from "../../context";
import { useImagesFromSubscriberSegments } from "../../hooks";

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    width: "1200px",
  },
  image: {
    width: "1050px",
    marginTop: "0.5rem",
  },
  actions: {
    width: "1050px",
    paddingBottom: "1rem",
    paddingRight: "1.1rem",
  },
  link: {
    color: theme.palette.primary.contrastText,

    "&:hover": {
      textDecoration: "none",
    },
  },
  btn: {
    width: "auto",
    paddingLeft: "0.7rem",
    paddingRight: "0.7rem",
    height: "30px",
    backgroundColor: "#008AFC",
    color: theme.palette.primary.contrastText,
    textTransform: "none",
  },
  navButton: {
    background: "none",
    border: "none",
    "& svg": { fontSize: 56, color: theme.palette.primary.main },
  },
}));

interface MarketingProps {}

const Marketing: FC<MarketingProps> = (props: MarketingProps) => {
  const classes = useStyles();
  const emailToAddress = "healthcare@ipdanalytics.com?";
  const emailSubject = "I want to learn more about Payer %26 Provider Insights&";
  const emailBody = "Please contact me.";
  const emailHref = `mailto:${emailToAddress}subject=${emailSubject}body=${emailBody}`;

  const ref = useRef(null);
  const { page1, page2 } = useImagesFromSubscriberSegments();

  const [visibilityContext, setVisibilityContext] = useContext(VisibilityContext);

  const handleCloseDialog = () => {
    setVisibilityContext({
      ...visibilityContext,
      marketing: false,
    });
  };

  return (
    <div>
      <Dialog maxWidth="xl" open={visibilityContext.marketing}>
        <DialogContent ref={ref}>
          <CarouselProvider isIntrinsicHeight naturalSlideWidth={100} naturalSlideHeight={125} totalSlides={2}>
            <Slider style={{ width: 1050 }}>
              <Slide index={0}>
                <img alt="marketing" src={page1} className={classes.image} />
              </Slide>
              <Slide index={1}>
                <img alt="marketing" src={page2} className={classes.image} />
              </Slide>
            </Slider>
            <DialogActions className={classes.actions}>
              <ButtonBack className={classes.navButton}>
                <ChevronLeft name="previous-slide" fontSize="small" />
              </ButtonBack>
              <DownloadPDF />
              <Link className={classes.link} href={emailHref}>
                <Button variant="contained" size="small" className={classes.btn}>
                  Setup a demo!
                </Button>
              </Link>
              <Button variant="contained" size="small" className={classes.btn} onClick={() => handleCloseDialog()}>
                Okay, I got it!
              </Button>
              <ButtonNext className={classes.navButton}>
                <ChevronRight name="next-slide" fontSize="small" />
              </ButtonNext>
            </DialogActions>
          </CarouselProvider>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Marketing;
